import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBTextArea, ObjectiveFlag } from '_components';

class PatientCareCenterNoteObjectiveObsAttentionPeds extends React.Component {

    render() {
            return (
                <PatientCareCenterNoteSection id='obj_obs_attention' name='Attention' level={2} noChildPadding={true}>
                  <div className={styles.form_row}>
                  <div className={styles.gap}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Attention' />
                    </div>

                    <div className={styles.gap}>
                     <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPATTENTION'
                        className={styles.textarea}
                    />
                    </div>
                  </div>

                </PatientCareCenterNoteSection>
            );
       
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        opno: opno,
        flagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPATTENTION !== undefined 
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPATTENTION !== null 
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPATTENTION !== '')
    };
}

const connectedPatientCareCenterNoteObjectiveObsAttentionPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsAttentionPeds);
export { connectedPatientCareCenterNoteObjectiveObsAttentionPeds as PatientCareCenterNoteObjectiveObsAttentionPeds };

